/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HospitalPatientAttribute from './hospital-patient-attribute';
import HospitalPatientAttributeDetail from './hospital-patient-attribute-detail';
import HospitalPatientAttributeUpdate from './hospital-patient-attribute-update';
import HospitalPatientAttributeDeleteDialog from './hospital-patient-attribute-delete-dialog';

const HospitalPatientAttributeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HospitalPatientAttribute />} />
    <Route path="new" element={<HospitalPatientAttributeUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalPatientAttributeDetail />} />
      <Route path="edit" element={<HospitalPatientAttributeUpdate />} />
      <Route path="delete" element={<HospitalPatientAttributeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalPatientAttributeRoutes;
